/**
 * Microsoft Clarity Session Injector for Shopify Cart Adds
 *
 * Purpose: On click of add-to-cart buttons, synchronously reads the Clarity
 *          first-party cookies (_clsk = session, _clck = user), appends
 *          `clarity_sid` + `clarity_uid` to the button's `data-link`, then lets
 *          the event bubble to the jQuery turbo handler (which adds cart_hash
 *          and proceeds). No preventDefault / re-trigger — avoids loops/races.
 *          Bridge stores the pair on the cart and builds the replay deep-link:
 *          https://clarity.microsoft.com/player/{project}/{uid}/{sid}
 *
 * Notes:
 * - The ids are the first `^`-delimited segment of each cookie value.
 * - Silent fallback: if the cookies aren't set yet (rare by click time), the
 *   click bubbles without the params and nothing is stored.
 * - Clarity itself is loaded by the Microsoft Clarity Shopify app, not here.
 *
 * Dependencies: none (vanilla). Mirrors logrocket-set-session.js.
 */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('button[data-link*="https://shopify.trophydepot.com/cart/item/add"]');
  if (!btn) {
    return;
  }

  try {
    const sid = readClarityCookie('_clsk'); // session id
    const uid = readClarityCookie('_clck'); // user id (CLID)

    if (sid && uid) {
      const url = new URL(btn.getAttribute('data-link'), window.location.origin);
      url.searchParams.set('clarity_sid', sid);
      url.searchParams.set('clarity_uid', uid);
      btn.setAttribute('data-link', url.toString());
    }
  } catch (err) {
    // Silent — let the click bubble without the Clarity params.
  }
}, true); // Capture phase: runs before the bubbling jQuery on('click').

/**
 * Read a Clarity cookie and return its id (the first `^`-delimited segment).
 * Cookie values are URL-encoded, so `^` arrives as `%5E`; decode first.
 */
function readClarityCookie(name) {
  const cookie = document.cookie.split('; ').find(function (c) {
    return c.indexOf(name + '=') === 0;
  });

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.split('=')[1]).split('^')[0] || null;
}
